export function getTransitionEndEventName(): string | false {
	const element = document.createElement('_');
	const transitions = {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		WebkitTransition: 'webkitTransitionEnd',
		transition: 'transitionend',
	};

	for (const transition in transitions) {
		if (element.style[transition] !== undefined) {
			return transitions[transition];
		}
	}

	return false;
}
